

// Copy pasted from packages/ambrosia-lib/src/serializers/slate/constants.js of aero-sdk-ambrosia

// https://github.com/ianstormtaylor/slate/blob/master/examples/paste-html/index.js

export const LIST_TAGS = {
  li: 'list-item',
  ul: 'unordered-list',
  ol: 'ordered-list',
};

export const BLOCK_TAGS = {
  p: 'paragraph',
  blockquote: 'quote',
  pre: 'code',
  h1: 'heading-one',
  h2: 'heading-two',
  h3: 'heading-three',
  h4: 'heading-four',
  h5: 'heading-five',
  h6: 'heading-six',
};

/**
 * Tags to marks.
 *
 * @type {Object}
 */

export const MARK_TAGS = {
  strong: 'bold',
  em: 'italic',
  i: 'italic',
  u: 'underlined',
  s: 'strikethrough',
  sup: 'superscript',
  sub: 'subscript',
  code: 'code',
  b: 'bold',
  cite: 'italic',
};

const RULES = [
  {
    deserialize(el, next) {
      const block = BLOCK_TAGS[el.tagName.toLowerCase()];
      if (block) {
        return {
          object: 'block',
          type: block,
          nodes: next(el.childNodes),
        };
      }
    },
  },
  {
    deserialize(el, next) {
      const mark = MARK_TAGS[el.tagName.toLowerCase()];

      if (mark) {
        return {
          object: 'mark',
          type: mark,
          nodes: next(el.childNodes),
        };
      }
    },
  },
  {
    // Special case for ol and ul, to grab their type.
    deserialize(el, next) {
      const mark = LIST_TAGS[el.tagName.toLowerCase()];
      if (mark) {
        return {
          object: 'block',
          type: mark,
          data: getDataProps(el),
          nodes: next(el.childNodes),
        };
      }
    },
  },
  {
    // Special case for code blocks, which need to grab the nested childNodes.
    deserialize(el, next) {
      if (el.tagName.toLowerCase() === 'pre') {
        const code = el.childNodes[0];
        const childNodes = code && code.tagName.toLowerCase() === 'code' ? code.childNodes : el.childNodes;

        return {
          object: 'block',
          type: 'code',
          nodes: next(childNodes),
        };
      }
    },
  },
  {
    // Special case for images, to grab their src.
    deserialize(el, next) {
      if (el.tagName.toLowerCase() === 'img') {
        return {
          object: 'block',
          type: 'image',
          nodes: next(el.childNodes),
          data: {
            src: el.getAttribute('src'),
          },
        };
      }
    },
  },
  {
    // Special case for links, to grab their href.
    deserialize(el, next) {
      if (el.tagName.toLowerCase() === 'a') {
        return {
          object: 'inline',
          type: 'link',
          nodes: next(el.childNodes),
          data: {
            href: el.getAttribute('href'),
          },
        };
      }
    },
  },
  {
    // MathML
    deserialize(el) {
      if (el && el.tagName.toLowerCase() === 'math') {
        return {
          object: 'inline',
          type: 'mathml-expression',
          data: {
            mathML: cleanMathML(el.outerHTML),
            display: el.getAttribute('display') || 'inline',
          },
        };
      }
    },
  },
  {
    // Special case for text in li to prepare text as a leaf for li
    deserialize(el) {
      if (el.nodeName === '#text' && el.parentElement && el.parentElement.tagName.toLowerCase() === 'li') {
        return {
          object: 'text',
          leaves: [
            {
              object: 'leaf',
              text: el.textContent,
            },
          ],
        };
      }
    },
  },
  {
    // Special case for "expression" tags (only used by ePub Adapters project)
    //
    deserialize(el) {
      if (el && el.tagName.toLowerCase() === 'expression') {
        return {
          object: 'inline',
          type: 'mathml-expression',
          data: {
            mathML: cleanMathML(el.getAttribute('mathML') || ''),
            display: el.getAttribute('display') || 'inline',
          },
        };
      }
    },
  },
];

/**
 * Removes namespaces and irrelevant data attributes to simplify the mathml
 * and make it cleaner for mathml generator services.
 **/
function cleanMathML(mathML) {
  let cleanMathML = mathML;
  try {
    cleanMathML = cleanMathML.replace(/( xmlns="http:\/\/www.w3\.org\/1998\/Math\/MathML")+/g, '');
    // eslint-disable-next-line
    cleanMathML = cleanMathML.replace(/( data-chaucer-element-id="[a-z\d-]{36}")+/g, '');
    cleanMathML = cleanMathML.replace(/(&nbsp;)+/g, ' ');
    // BRNT-247 svg conversion fails when we encounter special chars '<<' or '>>'
    cleanMathML = cleanMathML.replace(/(<<)+/g, '&lt;<');
    cleanMathML = cleanMathML.replace(/(>>)+/g, '>&gt;');
    // BRNT-365 accessibility text generation fails when empty <m:mi/> tag is present
    cleanMathML = cleanMathML.replace(/(<m:mi\/ >)+/g, '');
  } catch (error) {
    // swallow errors
    // eslint-disable-next-line
    console.error(
      `Error cleaning mathml (${error.message ||
        error}). This should not cause any issues - we'll proceed with the original data`
    );
  }

  return cleanMathML.length > 0 ? cleanMathML : mathML;
}

/**
 * Function returns object containing data props depending on the element passed
 * @param {Object} el - object containing html and it's attributes
 */
function getDataProps(el) {
  if (el.tagName.toLowerCase() === 'li') {
    return { direction: 'auto' };
  } else {
    return {
      listOptionType: el.type ? el.type : '',
      startValue: el.start ? el.start : '',
    };
  }
}

export default RULES;
